// removed by extract-text-webpack-plugin
module.exports = {"modal-overlay":"Modal-modal-overlay"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/theme/rlink-modal/Modal.less
// module id = 139
// module chunks = 0